import React, { useState } from "react";
import { Palette } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { FontSelect, ColorSwatch } from "./BeaconStylePanel";

// Owner-only: pick a font + colour for the Hearth's community name (saves instantly).
export const HearthTitleStyle = ({ hearthId, meta, onSaved }) => {
  const [open, setOpen] = useState(false);
  const save = async (patch) => {
    onSaved(patch);
    try { await api.patch(`/hearths/${hearthId}`, patch); }
    catch { toast.error("Couldn't save the title style"); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" title="Title style" aria-label="Title style" data-testid="hearth-title-style-btn" className="text-zinc-600 hover:text-[#14A89A]"><Palette size={14} /></button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3 bg-[#121212] border-white/15 space-y-3" data-testid="hearth-title-style-menu" onInteractOutside={(e) => { if (e.target.closest?.("[role=listbox],[data-radix-popper-content-wrapper]")) e.preventDefault(); }}>
        <div className="font-body text-[10px] tracking-[0.15em] uppercase text-zinc-500">Community name style</div>
        <div className="grid grid-cols-[1fr_auto] gap-2 items-center">
          <FontSelect value={meta.title_font} allowMatch onPick={(v) => save({ title_font: v })} testid="hearth-title-font" matchLabel="Default" />
          <ColorSwatch value={meta.title_color} fallback="#FFFFFF" accent="#14A89A" allowMatch onPick={(v) => save({ title_color: v })} testid="hearth-title-color" matchLabel="Default (white)" />
        </div>
        <p className="font-body text-[11px] text-zinc-600">"Default" uses the standard SovSig style.</p>
      </PopoverContent>
    </Popover>
  );
};
